import { Store } from '@tanstack/store'

// Load initial selected language from localStorage
const selectedLanguage = localStorage.getItem('selectedLanguage') || 'en'

// If not set before, store 'en' in localStorage
if (!localStorage.getItem('selectedLanguage')) {
    localStorage.setItem('selectedLanguage', 'en')
}

export const selectedLanguageStore = new Store({
    selectedLanguage,
})

export const setSelectedLanguage = (value) => {
    localStorage.setItem('selectedLanguage', value)
    selectedLanguageStore.setState((prev) => ({
        ...prev,
        selectedLanguage: value
    }))
}